(function(){
"use strict";
function qs(sel,ctx){return (ctx||document).querySelector(sel)}
var input = qs("[data-predictive-input]");
if(!input) return;
var resultsBox = qs("[data-predictive-results]");
var base = input.getAttribute("data-predictive-url");
var timer;
input.addEventListener("input", function(){
  clearTimeout(timer);
  var term = input.value.trim();
  if(!resultsBox) return;
  if(term.length < 2){ resultsBox.classList.remove("is-open"); resultsBox.innerHTML=""; return; }
  timer = setTimeout(function(){
    fetch(base + "?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=5")
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if(products.length === 0){
          resultsBox.innerHTML = '<button type="button" data-term="'+term.replace(/"/g,"&quot;")+'" style="display:flex;align-items:center;gap:12px;width:100%;padding:12px 18px;background:none;border:none;cursor:pointer;font-size:15px;color:var(--color-ink);text-align:left"><i class="ph-light ph-magnifying-glass" aria-hidden="true"></i>Buscar "'+term+'"</button>';
        } else {
          resultsBox.innerHTML = products.map(function(p){
            return '<button type="button" data-url="'+p.url+'" style="display:flex;align-items:center;gap:12px;width:100%;padding:12px 18px;background:none;border:none;border-bottom:1px solid var(--border-hairline);cursor:pointer;font-size:15px;color:var(--color-ink);text-align:left"><i class="ph-light ph-magnifying-glass" aria-hidden="true" style="color:var(--color-muted)"></i><span>'+p.title+'</span><span style="margin-left:auto;font-size:12px;color:var(--color-muted)">'+(p.price||"")+'</span></button>';
          }).join("");
        }
        resultsBox.classList.add("is-open");
      })
      .catch(function(){ resultsBox.classList.remove("is-open"); });
  }, 220);
});
document.addEventListener("click", function(e){
  var btn = e.target.closest("[data-predictive-results] button");
  if(btn){
    if(btn.getAttribute("data-url")){ window.location.href = btn.getAttribute("data-url"); }
    else if(btn.getAttribute("data-term")){ input.value = btn.getAttribute("data-term"); var f=input.closest("form"); if(f) f.submit(); }
  }
  if(resultsBox && !e.target.closest(".p47-searchbar")){ resultsBox.classList.remove("is-open"); }
});
})();
